import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "sonner";
import { AuthActions } from "store/ducks/auth";

export function useErrorHandler() {
  const dispatch = useDispatch();
  const setLogout = useCallback(() => {
    dispatch(AuthActions.logoutRequest());
  }, [dispatch]);

  const errorHandler = (errorResponse: any | Error) => {
    const error = errorResponse?.response?.data || null;
    console.log({ errorHandler: error });
    if (error?.code === "E_APP") {
      toast("Erro", {
        description: error.message,
      });
      return;
    }
    if (error?.code === "E_EXCEPTION") {
      toast("Erro", {
        description: error.message,
      });
      return;
    }

    if (error?.code === "ERR_NETWORK") {
      console.log("Network error");
      toast("Erro de rede", {
        description: "Verifique sua conexão com a internet",
      });
      return;
    }

    if (error?.code === "ECONNABORTED") {
      console.log("Timeout error");
      toast("Erro de tempo limite", {
        description: "Verifique sua conexão com a internet",
      });
      return;
    }

    if (error?.code === "ERR_BAD_REQUEST") {
      if (error?.response?.data?.error.code === "E_VALIDATION") {
        console.log("Validation error");
        const errors: string[] = [];
        error.response.data.error.message.forEach((error: any) => {
          errors.push(error.message);
        });

        errors.forEach((error) => {
          toast("Erro de validação", {
            description: error,
          });
        });
      }

      if (error?.response?.data?.errors?.length > 0) {
        const errors: string[] = [];
        error.response.data.errors.forEach((error: any) => {
          errors.push(error.message);
        });

        errors.forEach((error) => {
          toast("Erro na requisição", {
            description: error,
          });
        });
      }

      if (error?.response?.data?.error) {
        const err = error.response.data.error;

        if (err.code === "E_TOKEN_REVOKED") {
          toast("Sessão expirada", {
            description: "Faça login novamente",
          });
          setLogout();
        }

        if (err.code === "E_APP" && error.response.status === 401) {
          toast("Não autorizado", {
            description: err.message,
          });
        }

        if (err.code === "E_INTERNAL_ADONIS_ERROR") {
          toast("Erro interno", {
            description: err.message,
          });
        }
      }

      return;
    }

    if (error?.code) {
      toast("Erro", {
        description:
          "Não foi possível processar sua solicitação. Tente novamente mais tarde.",
      });
      return;
    }
    return <></>;
  };

  return { errorHandler };
}
